import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useAutoTranslation } from './../../../../helpers/useAutoTranslation';

const UploadingWarehouseInfoIcon = (props) => {
  const { currentOrder, isWrong } = props;

  const { t } = useAutoTranslation();

  const warehouses = useSelector((state) => state.orders.warehouses);
  const currentWarehouse = warehouses.find((w) => w.code === currentOrder.warehouseCode);

  const onClick = (e) => e.preventDefault();

  const defineIconAndTooltipText = () => {
    if (currentOrder.warehouseFFExportError || isWrong(currentOrder)) {
      return (
        <>
          <i className="fe-alert-triangle" style={{ color: `#f1556c` }} />
          <span className="help-tooltip">
            {typeof currentOrder.warehouseFFExportError === 'string'
              ? currentOrder.warehouseFFExportError
              : t('Ошибка выгрузки заказа на фулфилмент')}
          </span>
        </>
      );
    } else if (currentOrder.warehouseFFSyncDate) {
      return (
        <>
          <i className="fe-play-circle" style={{ color: `#1abc9c` }} />
          <span className="help-tooltip">
            {t('Заказ успешно выгружен в систему Фулфилмент')}:{` `}
            {currentOrder.warehouseFFSyncDate &&
              moment(currentOrder.warehouseFFSyncDate).format(`DD.MM.YYYY HH:mm:ss`)}
          </span>
        </>
      );
    } else if (!currentOrder.warehouseFFExported) {
      return (
        <>
          <i className="fe-pause-circle" style={{ color: `#98a6ad` }} />
          <span className="help-tooltip">
            {currentOrder.warehouseFFExportError && currentOrder.warehouseFFExportError}
            {t('Заказ еще не выгружался в систему Фулфилмент')}
          </span>
        </>
      );
    } else {
      return null;
    }
  };

  return currentWarehouse?.operatorType === `FULFILLMENT` ? (
    <div
      className="warehouse-type"
      onClick={onClick}
      style={{ paddingTop: '10px', marginTop: '-10px', paddingRight: '10px' }}
    >
      <span className="help-tooltip-wrapper">
        {currentOrder ? defineIconAndTooltipText() : null}
      </span>
    </div>
  ) : null;
};

export default UploadingWarehouseInfoIcon;
